import {
  Component,
  ChangeDetectionStrategy,
  computed,
  input,
} from '@angular/core';

export type BadgeVariant =
  | 'primary'
  | 'secondary'
  | 'success'
  | 'danger'
  | 'info'
  | 'warning'
  | 'light'
  | 'dark';

export type BadgeShape = 'default' | 'pill';
export type BadgeType = 'filled' | 'soft';

@Component({
  selector: 'ps-badge',
  standalone: true,
  template: `
    <span class="badge" [class]="badgeClasses()">
      <ng-content />
    </span>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BadgeComponent {
  public readonly variant = input<BadgeVariant>('primary');
  public readonly shape = input<BadgeShape>('default');
  public readonly type = input<BadgeType>('filled');

  protected readonly badgeClasses = computed(() => {
    const typeClassMap: Record<BadgeType, string> = {
      filled: `text-bg-${this.variant()}`,
      soft: `text-bg-${this.variant()}-soft`,
    };
    const classes = [typeClassMap[this.type()]];

    if (this.shape() === 'pill') {
      classes.push('rounded-pill');
    }

    return classes;
  });
}
